export default __webpack_public_path__ + "static/media/2024_calendar_vert.04c4f77c.png";